__turbopack_context__.v({
  "closeButton": "Dialog-module__hj1VHa__closeButton",
  "scrollArea": "Dialog-module__hj1VHa__scrollArea",
});
